import React from 'react';
import { Badge } from '../../components/ui/badge';

export const getTierBadge = (u) => {
  if (u.role === 'superadmin') return <Badge className="bg-rose-500/20 text-rose-400 border-rose-500/30">Admin+</Badge>;
  if (u.role === 'admin') return <Badge className="bg-purple-500/20 text-purple-400 border-purple-500/30">Admin</Badge>;
  if (u.tier === 'premium') return <Badge className="bg-amber-500/20 text-amber-400 border-amber-500/30">Premium</Badge>;
  if (u.tier === 'standard') return <Badge className="bg-blue-500/20 text-blue-400 border-blue-500/30">Standard</Badge>;
  if (u.is_trial && u.trial_active) return <Badge className="bg-emerald-500/20 text-emerald-400 border-emerald-500/30">Trial</Badge>;
  return <Badge className="bg-slate-500/20 text-slate-400 border-slate-500/30">Free</Badge>;
};

export const getTrialInfo = (u) => {
  if (u.role === 'superadmin' || u.role === 'admin') return 'Full access';
  if (u.tier === 'premium' || u.tier === 'standard') return 'Subscribed';
  if (u.trial_active) return `${u.trial_days_remaining} days left`;
  return 'Trial expired';
};

export const formatDate = (dateStr) => {
  if (!dateStr) return 'N/A';
  try {
    return new Date(dateStr).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  } catch (err) {
    return 'N/A';
  }
};
